module.exports = __webpack_public_path__ + "images/day-2x.png";


//////////////////
// WEBPACK FOOTER
// ./images/day-2x.png
// module id = 1109
// module chunks = 1